import { Button, useModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import ClassroomInvitationModal from "@/classrooms/ClassroomInvitationModal";
import { buttonCss } from "./ClassroomCreatedMessage.style";

const propTypes = {
  classroom: PropTypes.object.isRequired,
};

const ClassroomCreatedMessage = ({ classroom }) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  return (
    <>
      Class created!
      <Button
        flavor={Button.flavors.tertiary}
        ref={triggerRef}
        __cssFor={buttonCss}
        onClick={() => setActive(true)}
      >
        Invite students
      </Button>
      <ClassroomInvitationModal
        classroomInvitationModalProps={modalProps}
        closeButtonProps={() => setActive(false)}
        classroom={classroom}
      />
    </>
  );
};

ClassroomCreatedMessage.propTypes = propTypes;

export default ClassroomCreatedMessage;
